export default __webpack_public_path__ + "static/media/folder-move.d718cc96.svg";